// @ts-strict-ignore
import {Component, Injector, OnInit} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {ServiceType, SystemStatusView} from "@models";
import {ComponentHealthErrors, HealthErrorLocation, SimHealthMonitorExtendedService} from "@services";
import {Translations} from "@translations";
import {EventEmitterService} from "@event-emitter";
import {Router} from "@angular/router";
import {routes} from "../../../../../../environments/routes";

export interface DialogData_HealthLevelReportDialog extends MatDialogDataBaseInput {}

export interface DialogData_HealthLevelReportDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-health-level-report-dialog",
	templateUrl: "./health-level-report-dialog.component.html",
	styleUrls: ["./health-level-report-dialog.component.scss"],
	providers: [EventEmitterService],
	standalone: false,
})
export class HealthLevelReportDialogComponent
	extends BasicMaterialDialog<
		HealthLevelReportDialogComponent,
		DialogData_HealthLevelReportDialog,
		DialogData_HealthLevelReportDialogOutput
	>
	implements OnInit
{
	T = Translations;
	protected readonly ServiceType = ServiceType;

	public componentErrors: ComponentHealthErrors[] = null;
	public loadingHealthReport: boolean = true;

	constructor(
		_injector: Injector,
		private _emitterService: EventEmitterService,
		private _simHealthMonitorService: SimHealthMonitorExtendedService,
		private _router: Router,
	) {
		super(_injector);
	}

	public ngOnInit() {
		super.ngOnInit();

		this._simHealthMonitorService.requestSystemStatusOverWs().then();
		this._emitterService.onHealthReported.subscribe((args) => {
			this.buildHealthReport(args.systemStatusView);
		});
	}

	private buildHealthReport(systemStatus: SystemStatusView) {
		if (systemStatus) {
			const hasAnyErrors = this._simHealthMonitorService.hasComponentErrors(systemStatus, {
				include: HealthErrorLocation.StartRecording,
			});

			if (hasAnyErrors) {
				this.componentErrors = this._simHealthMonitorService.getComponentErrors(systemStatus, {
					include: HealthErrorLocation.StartRecording,
				});
			} else {
				// SIMSOFT-2888
				this.close();
			}
		}
		this.loadingHealthReport = false;
	}

	navigateToHealthMonitor() {
		this._router.navigate([routes.routes.healthMonitor]).then();
	}
}
